import React, { useEffect } from 'react';
import { Grid, Box } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

type NameAndPronounsFieldsProps = {
  firstName?: string;
  lastName?: string;
  pronouns?: string;
};
const NameAndPronounsFields = (props: NameAndPronounsFieldsProps) => {
  const { firstName, lastName, pronouns } = props;

  const [firstNameValue, setFirstNameValue] = React.useState(firstName || '');
  const [lastNameValue, setLastNameValue] = React.useState(lastName || '');
  const [pronounsValue, setPronounsValue] = React.useState(pronouns || '');

  useEffect(() => {
    setFirstNameValue(firstName || '');
    setLastNameValue(lastName || '');
    setPronounsValue(pronouns || '');
  }, [firstName, lastName, pronouns]);

  return (
    <Grid display={'flex'} gap={5} flexDirection={'column'} p={5}>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='firstName'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          First Name
        </label>
        <Grid display={'flex'} gap={2} alignItems={'center'} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name='firstName'
              sx={{ width: '100%', maxWidth: '654px' }}
              value={firstNameValue}
              defaultValue={firstName || ''}
              onChange={() => {}}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='lastName'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          Last Name
        </label>
        <Grid display={'flex'} gap={2} alignItems={'center'} flex={1}>
          <Box sx={{ flexGrow: 1 }}>
            <CustomTextField
              name='lastName'
              sx={{ width: '100%', maxWidth: '654px' }}
              value={lastNameValue}
              defaultValue={lastName || ''}
              onChange={() => {}}
            />
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6} display={'flex'} flexDirection={'column'}>
        <label
          htmlFor='pronouns'
          style={{
            fontWeight: 700,
            fontSize: '18px',
            color: '#000000',
            marginLeft: '10px',
          }}>
          Pronouns
        </label>
        <Box sx={{ flexGrow: 1 }}>
          <CustomTextField
            name='pronouns'
            sx={{ width: '100%', maxWidth: '654px' }}
            value={pronounsValue}
            defaultValue={pronouns || ''}
            onChange={() => {}}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default NameAndPronounsFields;
